import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  Typography,
} from "@mui/material";
import React from "react";
import { getIn } from "formik";

const errorMessage = () => {
  return (
    <Box>
      <Typography>Square Location</Typography>
      <Typography color={"error"}>
        No Square Locations available! An administrator must configure Square
        integration for the organization.
      </Typography>
    </Box>
  );
};
const SquareLocationPicker = ({
  formikProps,
  squareLocations,
  required,
  handleChange,
  disabled,
}) => {
  const {
    values,
    handleChange: formikHandleChange,
    handleBlur,
    touched,
    errors,
  } = formikProps;

  const key = "squareLocation";
  const touchedKey = getIn(touched, key);
  const errorKey = getIn(errors, key);
  const label = required ? "Payment Location *" : "Payment Location";

  return (squareLocations || []).length === 0 ? (
    errorMessage()
  ) : (
    <Box>
      <Box display={"flex"} gap={"20px"} marginTop={"20px"}>
        <FormControl
          sx={{ width: "350px" }}
          fullWidth
          error={Boolean(errorKey && touchedKey)}
        >
          <InputLabel id="square-location-label">{label}</InputLabel>
          <Select
            disabled={disabled}
            id={key}
            name={key}
            labelId="square-location-label"
            label={label}
            value={values[key] || ""}
            onBlur={handleBlur}
            onChange={async (e) => {
              await formikHandleChange(e);
              if (handleChange) {
                await handleChange(e);
              }
            }}
            required={required}
          >
            {squareLocations.map(({ id, name }) => {
              return (
                <MenuItem key={`"suqre-location-${id}`} value={id}>
                  {name}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText>
            {touchedKey && errorKey ? errorKey : " "}
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  );
};

export default SquareLocationPicker;
